import { useEffect, useState } from 'react'

const getSystemTheme = (): 'light' | 'dark' => {
	if (typeof window !== 'undefined') {
		return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
	}
	return 'light'
}

const useTheme = (): 'light' | 'dark' => {
	const [theme, setTheme] = useState<'light' | 'dark'>(getSystemTheme)

	useEffect(() => {
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
		
		setTheme(mediaQuery.matches ? 'dark' : 'light')

		const handleChange = (e: MediaQueryListEvent) => {
			setTheme(e.matches ? 'dark' : 'light')
		}

		mediaQuery.addEventListener('change', handleChange)

		return () => {
			mediaQuery.removeEventListener('change', handleChange)
		}
	}, [])

	return theme
}

export default useTheme
